import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const CactusIcon = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="currentColor"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M11.2 0C10.6462 0 10.1049 0.164217 9.6444 0.471885C9.18395 0.779553 8.82506 1.21685 8.61314 1.72849C8.40121 2.24012 8.34576 2.80311 8.4538 3.34625C8.56184 3.8894 8.82851 4.38831 9.2201 4.7799C9.61169 5.17149 10.1106 5.43816 10.6537 5.5462C11.1969 5.65424 11.7599 5.59879 12.2715 5.38686C12.7831 5.17494 13.2204 4.81605 13.5281 4.3556C13.8358 3.89514 14 3.35379 14 2.8C14 2.05739 13.705 1.3452 13.1799 0.820101C12.6548 0.294999 11.9426 0 11.2 0ZM9.1 12.6H7.7V11.2C7.7 11.0143 7.62625 10.8363 7.49497 10.705C7.3637 10.5737 7.18565 10.5 7 10.5C6.81435 10.5 6.6363 10.5737 6.50503 10.705C6.37375 10.8363 6.3 11.0143 6.3 11.2V12.6H4.9V10.234L7.315 9.023C7.43044 8.96483 7.52752 8.87583 7.59547 8.76587C7.66343 8.6559 7.69961 8.52927 7.7 8.4V5.6C7.7 5.41435 7.62625 5.2363 7.49497 5.10503C7.3637 4.97375 7.18565 4.9 7 4.9C6.81435 4.9 6.6363 4.97375 6.50503 5.10503C6.37375 5.2363 6.3 5.41435 6.3 5.6V7.966L4.9 8.666V4.2C4.9 4.01435 4.82625 3.8363 4.69497 3.70503C4.5637 3.57375 4.38565 3.5 4.2 3.5C4.01435 3.5 3.8363 3.57375 3.70503 3.70503C3.57375 3.8363 3.5 4.01435 3.5 4.2V10.066L2.1 9.366V7.7C2.1 7.51435 2.02625 7.3363 1.89497 7.20503C1.7637 7.07375 1.58565 7 1.4 7C1.21435 7 1.0363 7.07375 0.905025 7.20503C0.77375 7.3363 0.7 7.51435 0.7 7.7V9.8C0.700392 9.92927 0.736571 10.0559 0.804526 10.1659C0.872482 10.2758 0.96956 10.3648 1.085 10.423L3.5 11.634V12.6H0.7C0.514348 12.6 0.336301 12.6737 0.205025 12.805C0.0737498 12.9363 0 13.1143 0 13.3C0 13.4857 0.0737498 13.6637 0.205025 13.795C0.336301 13.9263 0.514348 14 0.7 14H9.1C9.28565 14 9.4637 13.9263 9.59497 13.795C9.72625 13.6637 9.8 13.4857 9.8 13.3C9.8 13.1143 9.72625 12.9363 9.59497 12.805C9.4637 12.6737 9.28565 12.6 9.1 12.6Z" />
  </svg>
)
const ForwardRef = forwardRef(CactusIcon)
export { ForwardRef as ReactComponent }
